// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .Dots button {
    background: lime!important;
    margin: 0 4px;
    border-radius: 50%;
    padding: 0;
    width: 10px;
    height: 10px;
    font-size: 0;
    line-height: 0;
} */

.react-Slidy-arrow {
    display: none!important;
}`, "",{"version":3,"sources":["webpack://./src/components/BannerPromo/reactSlidy.css"],"names":[],"mappings":"AAAA;;;;;;;;;GASG;;AAEH;IACI,uBAAuB;AAC3B","sourcesContent":["/* .Dots button {\n    background: lime!important;\n    margin: 0 4px;\n    border-radius: 50%;\n    padding: 0;\n    width: 10px;\n    height: 10px;\n    font-size: 0;\n    line-height: 0;\n} */\n\n.react-Slidy-arrow {\n    display: none!important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
